import { useEffect, useState } from 'react';
var useViewportSizes = function () {
    var _a = useState(window.innerWidth), viewportWidth = _a[0], setViewportWidth = _a[1];
    var _b = useState(window.innerHeight), viewportHeight = _b[0], setViewportHeight = _b[1];
    useEffect(function () {
        var viewportSizeHandler = function () {
            setViewportWidth(window.innerWidth);
            setViewportHeight(window.innerHeight);
        };
        window.addEventListener('resize', viewportSizeHandler);
        return function () {
            window.removeEventListener('resize', viewportSizeHandler);
        };
    }, []);
    return { viewportWidth: viewportWidth, viewportHeight: viewportHeight };
};
export default useViewportSizes;
//# sourceMappingURL=useViewportSizes.js.map